var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.header.hide
    ? _c(
        "th",
        {
          class: _vm.headerClass,
          style: _vm.headerStyle,
          on: { click: _vm.onSort },
        },
        [
          _c(
            "v-menu",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasValue,
                  expression: "hasValue",
                },
              ],
              staticStyle: { flex: "0 0" },
              attrs: {
                "min-width": "180px",
                "close-on-content-click": false,
                "offset-y": "",
              },
              on: { input: _vm.onInput },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "span",
                          { class: { "success--text": _vm.isSliced } },
                          [_vm._v(_vm._s(_vm.header.text))]
                        ),
                        _vm._v(" "),
                        _vm.sortable
                          ? _c(
                              "v-icon",
                              {
                                staticClass: "arrow flex-shrink-0",
                                class: { descending: _vm.descending },
                                attrs: { small: "" },
                              },
                              [_vm._v("arrow_upward")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              staticClass: "flex-shrink-0 ma-0",
                              attrs: {
                                disabled: _vm.disabled,
                                icon: "",
                                small: "",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            on
                          ),
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  color: _vm.isSliced ? "success" : "",
                                  small: "",
                                },
                              },
                              [_vm._v("filter_alt")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isSliced,
                                expression: "isSliced",
                              },
                            ],
                            staticClass: "flex-shrink-0 ma-0",
                            attrs: { icon: "", flat: "", small: "" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.reset()
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { color: "success" } }, [
                              _vm._v("close"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1127836006
              ),
              model: {
                value: _vm.menu,
                callback: function ($$v) {
                  _vm.menu = $$v
                },
                expression: "menu",
              },
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" },
                },
                [
                  _c(
                    "v-flex",
                    { staticStyle: { flex: "0 0 132px" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "py-2 title font-weight-medium" },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("filter_alt"),
                          ]),
                          _vm._v("\n          Filter values\n        "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        {
                          staticClass: "py-2",
                          staticStyle: {
                            "background-color": "#f7f7f7",
                            "border-bottom": "1px solid #dddddd",
                          },
                        },
                        [
                          _c("v-text-field", {
                            staticStyle: { border: "1px solid #ddd" },
                            attrs: {
                              loading: _vm.searching,
                              "hide-details": "",
                              clearable: "",
                              solo: "",
                              "single-line": "",
                              flat: "",
                              placeholder: "Search values",
                              "append-icon": "search",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.sliceCurrent()
                              },
                            },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pt-2" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "pa-0 mx-0 my-1",
                                  attrs: { small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setAll(true)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("Select All")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "pa-0 mx-0 my-1",
                                  attrs: { small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setAll(false)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("Select None")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  Object.keys(_vm.items).length == 0
                    ? _c(
                        "v-flex",
                        { staticStyle: { flex: "1 1" } },
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-title",
                                {
                                  staticClass:
                                    "align-center d-flex justify-center",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1 flex-grow-0",
                                      attrs: { icon: "success" },
                                    },
                                    [_vm._v("help_outline")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "body-1 flex-grow-0" },
                                    [_vm._v("No values to filter")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "v-flex",
                        {
                          ref: "virtualContainer",
                          staticStyle: {
                            flex: "1 1 200px",
                            width: "100%",
                            "min-height": "0",
                          },
                        },
                        [
                          _c(
                            "v-list",
                            {
                              staticClass: "py-0 slicer",
                              attrs: { flat: "", dense: "" },
                            },
                            [
                              _c("ItemsScroller", {
                                ref: "itemsScroller",
                                attrs: { items: _vm.updatedItems },
                                on: {
                                  toggle: function ($event) {
                                    return _vm.toggle($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticStyle: { flex: "0 0 40px" } },
                    [
                      _vm.slowMode
                        ? _c(
                            "v-layout",
                            { staticClass: "px-1" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    block: "",
                                    color: "success",
                                    loading: _vm.loading,
                                    disabled:
                                      Object.keys(_vm.items).length == 0,
                                    small: "",
                                  },
                                  on: { click: _vm.triggerAndClose },
                                },
                                [_vm._v(_vm._s(_vm.$t("Button.Update")))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.hasValue,
                  expression: "!hasValue",
                },
              ],
              staticClass: "pa-0 ma-0",
              attrs: { flat: "", small: "" },
            },
            [_vm._v(_vm._s(_vm.header.text))]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }